import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap";
import { formatCurrency } from "utils/currency";
import {
  QuotationItemType,
  QuotationItemTypeLabelMap,
} from "features/Quotations/constants/quotation.constants";
import { amcLineQuantity } from "features/Amc/utils/amcItems";
import { useAmcContractOverview } from "./AmcContractOverviewContext";

export default function AmcLineItemsTab() {
  const { contract } = useAmcContractOverview();
  const items = contract?.items ?? [];

  const subTotal = items.reduce(
    (sum, ln) =>
      sum + (Number.isFinite(Number(ln.amount)) ? Number(ln.amount) : 0),
    0,
  );

  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Bill of quantities</h5>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <Table className="table-nowrap align-middle mb-0">
                <thead className="table-light text-muted">
                  <tr>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Unit</th>
                    <th scope="col" className="text-end">
                      Qty
                    </th>
                    <th scope="col" className="text-end">
                      Rate
                    </th>
                    <th scope="col" className="text-end">
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.length ? (
                    items.map((ln, idx) => {
                      const type = ln.type as QuotationItemType | undefined;
                      const typeLabel =
                        type && type in QuotationItemTypeLabelMap
                          ? QuotationItemTypeLabelMap[type]
                          : (ln.type ?? "—");

                      const desc =
                        String(ln.description ?? "").trim() ||
                        String(ln.quotationItem?.description ?? "").trim() ||
                        "—";

                      const productName = String(ln.product?.name ?? "").trim();
                      const q = amcLineQuantity(ln);

                      return (
                        <tr key={ln.id ?? idx}>
                          <td className="text-muted">{typeLabel}</td>
                          <td>
                            <span
                              className="text-body fw-medium"
                              style={{ whiteSpace: "pre-wrap" }}
                            >
                              {desc}
                            </span>
                            {productName ? (
                              <div className="text-muted small">
                                {productName}
                              </div>
                            ) : null}
                          </td>
                          <td className="text-muted">
                            {String(ln.unit ?? "").trim() || "—"}
                          </td>
                          <td className="text-end">x{q}</td>
                          <td className="text-end">
                            {ln.rate != null
                              ? formatCurrency(Number(ln.rate))
                              : "—"}
                          </td>
                          <td className="text-end">
                            {ln.amount != null
                              ? formatCurrency(Number(ln.amount))
                              : "—"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-muted py-4">
                        This contract has no bill-of-quantities lines.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {items.length > 0 ? (
              <div className="table-responsive table-card mt-4">
                <Table className="table-borderless align-middle mb-0">
                  <tbody>
                    <tr className="table-active">
                      <th scope="row">Total</th>
                      <td className="text-end">
                        <span className="fw-semibold fs-15">
                          {formatCurrency(subTotal)}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
